import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import styles from './CourseRankList.module.less';
import { addClass, removeClass } from '../../utils/utils';
import { logging } from '../../actions/log';
import EduCard from '../../components/EduCard/EduCard';
import { education } from '../../constants/storageKeys';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const swiperParams = {
  speed: 600,
  slidesPerGroup: 3,
  spaceBetween: 12,
  slidesPerView: 'auto',
  allowTouchMove: false,
};
export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const LOG_ACTION_SOURCE = {
    c_change: `${logInfo.tag}_Group_ChangePage`,
    source: `${logInfo.tag}_Group`,
  };

  const swiperEl = useRef(null);
  const swiperNext = useRef(null);
  const swiperPrev = useRef(null);
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
        org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
      });
    }
  }, [inView]);

  const handleShowNextPrev = useCallback(flag => {
    if (swiperEl && swiperEl.current && swiperEl.current.swiper) {
      const swiperObj = swiperEl.current.swiper;
      if (flag === 'next') {
        swiperObj.slideNext();
      }
      if (flag === 'prev') {
        swiperObj.slidePrev();
      }
      if (swiperPrev && swiperPrev.current && swiperNext && swiperNext.current) {
        // eslint-disable-next-line no-unused-expressions
        swiperObj.isEnd
          ? addClass(swiperNext.current, styles.swiper_soft_hidden)
          : removeClass(swiperNext.current, styles.swiper_soft_hidden);
        // eslint-disable-next-line no-unused-expressions
        swiperObj.isBeginning
          ? addClass(swiperPrev.current, styles.swiper_soft_hidden)
          : removeClass(swiperPrev.current, styles.swiper_soft_hidden);
      }

      const pageCardContentId = data && data.dataList && data.dataList[0].pageCardContentId;
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_change,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            title: data.title,
            pageCardContentId,
            nextOrPrev: flag,
            pageNum: swiperObj.snapIndex + 1,
            age_period: localStorage.getItem(education.EDUSTAGE),
          },
        }),
      );
    }
  });

  return data &&
    data.dataList &&
    data.dataList[0] &&
    data.dataList[0].courseList &&
    data.dataList[0].courseList.length > 3 ? (
    <div
      className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
      ref={ref}
      data-item={data.cardType}
    >
      <div className={styles.card} ref={refDom}>
        {inViewDom && (
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
            </div>
            <div className={styles.card_softs}>
              <Swiper {...swiperParams} ref={swiperEl}>
                {data.dataList[0] &&
                  data.dataList[0].courseList.map((item, j) => (
                    <div key={j} className={styles.swiper_soft}>
                      <EduCard
                        data={item}
                        tag="left"
                        hasDelete={false}
                        type="reading"
                        logInfo={{
                          pageCardId:
                            data &&
                            data.dataList &&
                            data.dataList[0] &&
                            data.dataList[0].pageCardContentId,
                          pageCardTitle: data && data.title,
                          rankCode:
                            data && data.dataList && data.dataList[0] && data.dataList[0].code,
                          cardType: data && data.cardType,
                          org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
                        }}
                      />
                    </div>
                  ))}
              </Swiper>
              <div
                className={`${styles.swiper_soft_prev} ${styles.swiper_soft_hidden}`}
                onClick={() => {
                  handleShowNextPrev('prev');
                }}
                ref={swiperPrev}
              />
              {data.dataList[0] && data.dataList[0].courseList.length > 3 && (
                <div
                  className={styles.swiper_soft_next}
                  onClick={() => {
                    handleShowNextPrev('next');
                  }}
                  ref={swiperNext}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
